export default {"src":"/_next/static/media/ic_posta.a930c116.svg","height":17,"width":20};